module.exports = __webpack_public_path__ + "static/censer_of_controlling_air_elementals-56438cb015f355931af850bb1dfae2f8.jpeg";